export class LoginFormModel {
    constructor(companyid='', userid='', password='') {
        this.companyid = companyid;
        this.userid = userid;
        this.password = password;
    }
}
